<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y67.jpg" />
      <!-- <div class="nbana nbana_xw">
        <p class="on"><a href="xw_l.html">企业动态</a></p>
        <p><a href="xw_l.html">行业快讯</a></p>
        <p><a href="xw_l.html">深度阅读</a></p>
        <div class="clearfix"></div>
      </div> -->
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">新闻资讯</a></p>
      </div>
    </div> -->
    <!--新闻列表页-->
    <div class="neiy">
      <div class="commen">
        <div class="nbana nbana_xw mob">
          <p class="on"><a href="xw_l.html">企业动态</a></p>
          <p><a href="xw_l.html">行业快讯</a></p>
          <p><a href="xw_l.html">深度阅读</a></p>
          <div class="clearfix"></div>
        </div>
        <!-- <div class="bt reveal-inftop">
          <h6>企业动态</h6>
          <img src="@/view/images/y8.png">
        </div> -->
        <!-- <div class="xwla pc informshow">
          <el-carousel class="cardShowban" height="450px" :loop="true" indicator-position="outside" :interval="3000" arrow="never">
            <el-carousel-item>
              <div class="xwlaa">
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="clearfix"></div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="xwlaa">
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="clearfix"></div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="xwlaa">
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="xwlab fl">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
                <div class="clearfix"></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="xwla mob reveal-inftop">
          <div class="swiper-container" id="swiper_xwl">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="xwlab">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="xwlab">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="xwlab">
                  <a href="javascript:void(0);" @click="informdet(1)">
                    <div class="xwlab_t">
                      <img src="@/view/images/y65.jpg">
                      <p><span>19</span>2021.05</p>
                    </div>
                    <div class="xwlab_w">
                      <h6>印刷智能化的简要定义</h6>
                      <p>何为智能化？百度百科给出的定义如下：智能化是指由现代通讯与信息技术、计算机网络技术、行业技术、智能控制技术汇集而成的针对某一方面的应用。</p>
                      <img src="@/view/images/y21.png">
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="xwlb">
          <div
            class="xwlba reveal-inftop"
            v-for="(item, index) in datalist"
            :key="index"
          >
            <a href="javascript:void(0);" @click="informdet(item)">
              <div class="xwcba_a fl">
                <span>{{ item.day }}</span
                >{{ item.nianyue }}
              </div>
              <div class="xwcba_b fl">
                <h6>{{ item.title }}</h6>
                <p v-html="item.content" style="height:50px">
                  {{ item.content }}
                </p>
              </div>
              <img src="@/view/images/y21.png" />
              <div class="clearfix"></div>
            </a>
          </div>
        </div>
        <div
          class="jj_m"
          style="cursor:pointer;margin-bottom:30px;"
          v-show="showMore"
          @click="handleMore"
        >
          <a>查看更多</a>
        </div>
        <div class="NoMore" v-show="!showMore">
          没有更多了
        </div>
        <!-- <div class="ym reveal-inftop" style="display: none;">
          <p class="a"><a href="#">首页</a></p>
          <p class="a"><a href="#">上一页</a></p>
          <p class="on"><a href="#">1</a></p>
          <p><a href="#">2</a></p>
          <p><a href="#">...</a></p>
          <p><a href="#">6</a></p>
          <p class="a"><a href="#">下一页</a></p>
          <p class="a"><a href="#">末页</a></p>
        </div> -->
        <!-- <div class="ym reveal-inftop">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="2"
            layout="prev, pager, next"
            :total="Pagenum">
          </el-pagination>
        </div> -->
      </div>
    </div>
    <!--留言-->
    <!--    <coun-sel></coun-sel>-->
    <!-- <div class="lyan reveal-inftop">
      <div class="commen">
        <h6>给印工社留言，免费获取更多服务</h6>
        <div class="lyana">
          <input class="input1 fl" v-model="gongsi" type="text" onfocus="if(value=='您的公司') {value=''}"
                 onblur="if (value=='') {value='您的公司'}">
          <input class="input1 fl" v-model="mobile" type="text" onfocus="if(value=='您的联系方式') {value=''}"
                 onblur="if (value=='') {value='您的联系方式'}">
          <textarea class="fl" v-model="content" onfocus="if(value=='您的需求'){value=''}"
                    onblur="if (value ==''){value='您的需求'}"></textarea>
          <input class="input2 fl" type="submit" value="提交留言">
          <div class="clearfix"></div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { nianyue, day } from '../../static/public';
// import CounSel from "@/components/counsel";
export default {
  name: 'informationName',
  components: {
    // CounSel
  },
  data() {
    return {
      content: '您的需求',
      mobile: '您的联系方式',
      gongsi: '您的公司',
      currentPage: 0,
      Pagenum: 0,
      datalist: [],
      count: 10,
      showMore: true,
    };
  },
  methods: {
    init() {
      this.newlist();
    },
    // handleCurrentChange(val) {
    //   // console.log(`当前页: ${val}`);
    //   this.currentPage = val;
    //   this.newlist();
    // },
    handleMore() {
      if (this.datalist.length != this.Pagenum) {
        this.currentPage += 1;
        this.newlist();
        this.showMore = true;
      } else {
        this.showMore = false;
      }
    },
    informdet(item) {
      if(item.address) {
        window.open(item.address, '_blank')
      } else {
        this.$router.push({ path: `/informdet?id=${item.id}&&navaa=4` });
      }

    },
    // 新闻资讯
    newlist() {
      const _this = this;
      const currentPage = _this.currentPage - 1;
      const url = `${process.env.API_HOST
      }portal/new?count=${this.count}&page=${this.currentPage}`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'get',
        url,
        data: {},
      }).then((res) => {
        const json = res.data;
        if (json.code == 200) {
          const { data } = json.message;
          _this.Pagenum = data.totalCount;
          const datalist = data.list;
          const a = _this.datalist.concat(datalist);
          _this.datalist = a;
          for (let i = 0; i < datalist.length; i++) {
            const date = `${datalist[i].createTime}:00`;
            const datec = Number(new Date(date));
            datalist[i].nianyue = nianyue(datec);
            datalist[i].day = day(datec);
          }
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
.xwlaa {
  display: block !important;
}
</style>
<style>
.informshow .el-carousel__indicators--horizontal {
  width: 100% !important;
  position: absolute !important;
  bottom: 0% !important;
  left: 0 !important;
  transform: translateX(0) !important;
  z-index: 99 !important;
  text-align: center;
}

.informshow .el-carousel__button {
  cursor: pointer;
  width: 7px;
  height: 7px;
  margin: 0 2.5px;
  float: left;
  position: relative;
  transition: all ease 0 0.35s;
  background-color: #1f232a;
  border-radius: 50%;
  opacity: 1;
  transition: all ease 0.35s;
}

.informshow .el-carousel__indicator.is-active button {
  background-color: #f6b415;
  width: 30px;
  border-radius: 20px;
}
.NoMore {
  width: 147px;
  height: 39px;
  line-height: 37px;
  margin: 0 auto;
  text-align: center;
  transition: all ease 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/view/information.vue